// Zentrale Inhalte & Platzhalter. Betreiberangaben kommen aus /api/config,
// diese Texte sind aus der Bestandswebsite (mabuhay-cocktail.de) verdichtet.

export const BRAND = "Mabuhay";
export const BRAND_SUB = "Cocktail & Barista Catering";

// Eigene Eventfotos der Bestandswebsite (Betreiber-Quelle), lokal gehostet.
const imgTest = "/img/cocktail.jpg";
export const IMG = {
  cocktail: "/img/cocktail.jpg",
  barista: "/img/barista.jpg",
  messe: "/img/messe.jpg",
  hochzeit: "/img/hochzeit.jpg",
  personal: "/img/personal.jpg",
  kurse: "/img/kurse.jpg",
  abend: "/img/abend.jpg",
  kaffeebar: "/img/kaffeebar.jpg",
};

export const SERVICES = [
  {
    id: "cocktail_catering",
    path: "/cocktail-catering",
    title: "Cocktail-Catering",
    cardKicker: "Mobile Cocktailbar",
    cardText: "Klassische und moderne Signature-Drinks – mit frischen Zutaten, Premium-Spirituosen und eigener mobiler Bar.",
    heroTitle: "Cocktail-Catering für Ihr Event",
    heroBadge: "Firmenfeiern · Kick-offs · Empfänge",
    heroText: "Ihre mobile Cocktailbar komplett aus einer Hand: Bar, Getränke, Gläser, Eis und erfahrene Barkeeper.",
    benefits: [
      { t: "Komplettes Bar-Paket", d: "Mobile Barsysteme, Equipment, Gläser und Eis – wir bringen alles mit und bauen wieder ab." },
      { t: "Getränke nach Wunsch", d: "Klassiker, Signature-Drinks, hausgemachte Limonaden, Smoothies und hochwertige alkoholfreie Varianten." },
      { t: "Eingespielte Barcrew", d: "Erfahrene Barkeeper mit Eventroutine, hoher Schlagzahl und zuvorkommendem Auftreten." },
    ],
    faqs: [
      { q: "Für welche Veranstaltungen eignet sich das Cocktail-Catering?", a: "Für Firmenfeiern, Kick-offs, Empfänge, Messeabende und private Feiern – vom kleinen Kreis bis zur Großveranstaltung." },
      { q: "Gibt es alkoholfreie Cocktails?", a: "Ja. Hochwertige alkoholfreie Signature-Drinks gehören zu jeder Getränkekarte dazu – ebenso Limonaden und Smoothies." },
      { q: "Welche Angaben werden für ein Angebot benötigt?", a: "Datum, Ort, ungefähre Gästezahl und gewünschte Leistung genügen – alles Weitere stimmen wir persönlich ab." },
    ],
  },
  {
    id: "barista_catering",
    path: "/barista-catering",
    title: "Barista-Catering",
    cardKicker: "Mobile Kaffeebar",
    cardText: "Siebträger-Kaffeekultur, Latte Art und Kaffeespezialitäten – für wache Gäste und gute Gespräche.",
    heroTitle: "Barista-Catering & mobile Kaffeebar",
    heroBadge: "Messen · Kongresse · Firmenevents",
    heroText: "Eigene Kaffeebar an Ihrem Stand oder Event: professionelle Siebträger-Maschinen, geschulte Baristas und Kaffeespezialitäten auf höchstem Niveau.",
    benefits: [
      { t: "Eigene Kaffeebar", d: "Komplette mobile Kaffeebar mit Siebträger-Maschine und Equipment – aufgebaut an fast jedem Ort." },
      { t: "Geschulte Baristas", d: "Langjährig erfahrene Baristas, die Ihre Gäste mit Latte Art und sympathischem Service begeistern." },
      { t: "Marketing-Plus", d: "Kaffeespezialitäten als Türöffner für Kundengespräche – auf Wunsch mit gebrandeten Kaffeepackungen als Goodie." },
    ],
    faqs: [
      { q: "Welche Anschlüsse werden für die Kaffeebar benötigt?", a: "In der Regel genügt ein normaler 230V-Anschluss. Details klären wir vorab in der Abstimmung." },
      { q: "Können Kaffee- und Cocktail-Service kombiniert werden?", a: "Ja, sehr gerne – beispielsweise Kaffeebar tagsüber und Cocktailbar am Abend. Wir stimmen das Konzept individuell ab." },
      { q: "Gibt es milchfreie Alternativen?", a: "Ja, pflanzliche Alternativen und verschiedene Kaffeespezialitäten sind individuell abstimmbar." },
    ],
  },
  {
    id: "messe_catering",
    path: "/messe-catering",
    title: "Messe-Catering",
    cardKicker: "Messeauftritt",
    cardText: "Cocktail- und Kaffeeservice direkt an Ihrem Messestand – als Gesprächseröffner und Publikumsmagnet.",
    heroTitle: "Messe-Barcatering für Ihren Messeauftritt",
    heroBadge: "Deutschlandweit & europaweit",
    heroText: "Ob mobile Kaffeebar am Vormittag, Cocktailbar zum Feierabend oder Standparty: Wir machen Ihren Messestand zum Treffpunkt.",
    benefits: [
      { t: "Gesprächseröffner", d: "Ein frischer Kaffee oder Cocktail lockert jedes Kundengespräch auf – und hält Besucher an Ihrem Stand." },
      { t: "Hohe Schlagzahl", d: "Eingespielte Abläufe und erfahrenes Personal bewältigen auch starken Besucherandrang." },
      { t: "Alles aus einer Hand", d: "Bar, Personal, Getränke und Logistik aus einer Hand – vom Aufbau bis zur Standparty." },
    ],
    faqs: [
      { q: "An welchen Messestandorten sind Sie im Einsatz?", a: "Deutschlandweit an allen gängigen Messestandorten – und nach Absprache europaweit." },
      { q: "Ist eine Standparty nach Messeschluss möglich?", a: "Ja, wir richten Cocktailempfänge und Standpartys aus – Getränkeauswahl und Ablauf stimmen wir individuell ab." },
      { q: "Wie kurzfristig ist eine Anfrage möglich?", a: "Fragen Sie einfach an – wir prüfen Datum und Kapazität umgehend und melden uns mit einer ehrlichen Rückmeldung." },
    ],
  },
  {
    id: "hochzeitscatering",
    path: "/hochzeitscatering",
    title: "Hochzeitscatering",
    cardKicker: "Hochzeitsbar",
    cardText: "Stilvoller Sektempfang und individuelle Hochzeits-Cocktails – abgestimmt auf Motto und Farben Ihrer Feier.",
    heroTitle: "Cocktail-Hochzeitscatering",
    heroBadge: "Für Ihren schönsten Tag",
    heroText: "Vom Sektempfang bis zur Party in der Nacht: eine Hochzeitsbar, die zu Ihrem Motto passt – mit Barkeepern, die Ihre Gäste verzaubern.",
    benefits: [
      { t: "Individuelles Konzept", d: "Getränkekarte, Bardesign und Deko stimmen wir eng mit Ihnen oder Ihrer Hochzeitsplanung ab." },
      { t: "Farblich abgestimmte Drinks", d: "Cocktails passend zu Motto und Farbwelt Ihrer Hochzeit – inklusive alkoholfreier Highlights." },
      { t: "Rundum sorglos", d: "Aufbau, Barbetrieb und Abbau übernehmen wir komplett – Sie feiern entspannt mit Ihren Gästen." },
    ],
    faqs: [
      { q: "Können wir eine eigene Getränkekarte zusammenstellen?", a: "Unbedingt – Lieblingsdrinks, Signature-Cocktail des Brautpaars und alkoholfreie Varianten stimmen wir persönlich ab." },
      { q: "Ist die Bar auch für Outdoor-Hochzeiten geeignet?", a: "Ja, unsere mobilen Barsysteme sind flexibel einsetzbar – indoor wie outdoor. Details klären wir bei der Abstimmung." },
      { q: "Kombinieren Sie auch Kaffee und Cocktails?", a: "Gerne – etwa Kaffeebar zum Kuchen am Nachmittag und Cocktailbar am Abend." },
    ],
  },
  {
    id: "personal",
    path: "/personal",
    title: "Barkeeper & Barista mieten",
    cardKicker: "Event-Personal",
    cardText: "Geprüfte, erfahrene Barkeeper und Baristas zur Ergänzung Ihres Event-Teams – zuverlässig und eingespielt.",
    heroTitle: "Barkeeper & Barista mieten",
    heroBadge: "Professionelles Personal",
    heroText: "Sie haben Location und Getränke bereits organisiert? Unsere erfahrenen Barkeeper und Baristas ergänzen Ihr Team – zuverlässig, schnell und sympathisch.",
    benefits: [
      { t: "Eingespielte Profis", d: "Unsere Crew arbeitet seit Jahren zusammen und bringt echte Eventroutine mit." },
      { t: "Flexibel buchbar", d: "Einzelne Barkeeper, Baristas oder komplette Barcrews – passend zu Größe und Ablauf Ihres Events." },
      { t: "Auch international", d: "Auf Englisch verständigen wir uns souverän – ideal für internationale Gäste und Messen." },
    ],
    faqs: [
      { q: "Kann nur Personal angefragt werden?", a: "Ja – Barkeeper und Baristas buchen Sie auch ohne Bar oder Getränkepaket von uns." },
      { q: "Bringt das Personal Equipment mit?", a: "Auf Wunsch ja – Shaker, Barwerkzeug und Cases bringen wir nach Absprache mit." },
      { q: "Wie läuft die Planung ab?", a: "Anfrage senden, Einsatz besprechen, Team zusammenstellen – mehr braucht es nicht." },
    ],
  },
  {
    id: "cocktailkurse",
    path: "/cocktailkurse",
    title: "Cocktailkurse & JGA",
    cardKicker: "Workshop & Kurs",
    cardText: "Interaktive Cocktailworkshops in Heidelberg – für Junggesellinnenabschiede, Teamevents und private Gruppen.",
    heroTitle: "Cocktailworkshops für JGA & Teams",
    heroBadge: "Heidelberg · ca. 3 Stunden",
    heroText: "Shaken, rühren, probieren: In rund drei Stunden zeigen unsere Barcoaches Ihrer Gruppe die Kunst des Mixens – inklusive Prosecco-Empfang und Urkunde.",
    benefits: [
      { t: "5 Cocktails selbst mixen", d: "Nach einer kurzen theoretischen Einführung geht es an die Praxis – jeder mixt und probiert mit." },
      { t: "Eigene Location in Heidelberg", d: "Der Workshop findet in Heidelberg-Rohrbach statt – zentral und gut erreichbar." },
      { t: "Urkunde & Booklet", d: "Alle Teilnehmenden erhalten Urkunde und Workshop-Booklet zur Erinnerung." },
    ],
    faqs: [
      { q: "Wie viele Personen können teilnehmen?", a: "Der Workshop startet ab 6 Personen – größere Gruppen stimmen wir individuell ab." },
      { q: "Wann finden die Workshops statt?", a: "Montag bis Sonntag nach Absprache. Ihr Wunschtermin wird für drei Tage als 1. Option reserviert." },
      { q: "Was kostet der Workshop?", a: "Die Preise beginnen laut Bestandsangebot ab 79 € pro Person – das aktuelle Angebot erhalten Sie auf Anfrage." },
    ],
  },
];

export const EVENT_TYPES = [
  "Messe / Messestand",
  "Firmenfeier / Firmenevent",
  "Hochzeit / private Feier",
  "JGA / Teamevent",
  "Sonstiges",
];

export const HOME_FAQS = [
  { q: "Für welche Veranstaltungen eignet sich das Catering?", a: "Für Messen, Firmenfeiern, Kick-offs, Hochzeiten und private Feiern – vom kleinen Empfang bis zur Großveranstaltung." },
  { q: "Welche Angaben werden für ein Angebot benötigt?", a: "Gewünschte Leistung, Datum, Ort und ungefähre Gästezahl genügen. Alles Weitere stimmen wir persönlich ab – kostenlos und unverbindlich." },
  { q: "Gibt es alkoholfreie Cocktails?", a: "Ja. Hochwertige alkoholfreie Signature-Drinks, Limonaden und Smoothies gehören zu jeder Getränkekarte dazu." },
  { q: "Können Cocktail- und Barista-Service kombiniert werden?", a: "Sehr gerne – zum Beispiel Kaffeebar am Tag und Cocktailbar am Abend. Wir stimmen das Konzept individuell ab." },
  { q: "Wo wird der Service angeboten?", a: "Deutschlandweit und nach Absprache europaweit – unsere mobilen Barsysteme sind an fast jedem Ort einsetzbar." },
  { q: "Kann nur Personal angefragt werden?", a: "Ja, Sie können Barkeeper und Baristas auch einzeln für Ihr Event buchen." },
  { q: "Wie läuft die Planung ab?", a: "Anfrage senden, Details abstimmen, Angebot erhalten – danach kümmern wir uns um Aufbau, Barbetrieb und Abbau." },
  { q: "Ist die Anfrage kostenlos und unverbindlich?", a: "Ja. Sie erhalten ein transparentes Angebot und entscheiden in Ruhe." },
];

export const SITELINKS = [
  { label: "Kostenloses Angebot", path: "/angebot", text: "Unverbindliches Angebot für Ihr Event anfordern" },
  { label: "Cocktail-Catering", path: "/cocktail-catering", text: "Mobile Cocktailbars für Firmenfeiern & Events" },
  { label: "Barista-Catering", path: "/barista-catering", text: "Mobile Kaffeebar mit Latte Art & Siebträger" },
  { label: "Messe-Catering", path: "/messe-catering", text: "Bar- & Kaffeeservice direkt am Messestand" },
  { label: "Hochzeitscatering", path: "/hochzeitscatering", text: "Stilvolle Hochzeitsbar für Ihren großen Tag" },
  { label: "Kontakt", path: "/kontakt", text: "Telefon, WhatsApp & E-Mail – sofort erreichbar" },
];
